/**
 * Format a canonical IBAN (no spaces) into 4-char groups for display.
 * Example: "GR1601101250000000012300695" → "GR16 0110 1250 0000 0001 2300 695"
 *
 * Storage is canonical (api/validators.mjs canonicalizes on save); display
 * is grouped for human readability. Copy-to-clipboard should still use the
 * canonical form — most banking apps strip spaces anyway.
 */
export function formatIban(iban) {
  if (!iban) return '';
  return iban.replace(/(.{4})/g, '$1 ').trim();
}
